<template>
  <div class="business-search-list">
    <div class="container">
      <div class="flex" style="align-items: center;margin-bottom: 25px;padding-top: 25px;">
        <span style="font-size: 14px;">当前位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item style="cursor: pointer;" :to="{name: 'businessSearch'}">商机线索</el-breadcrumb-item>
          <el-breadcrumb-item style="color: #009999">列表页</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-card class="search-box">
        <div class="businessSearch flex">
          <div class="businessSearchName">信息类型</div>
          <div class="businessSearchItem">
            <p :class="params.programUuid === items.uuid? 'businessSearch_m1': 'businessSearch_m'"
               v-for="(items, index) in paramsTypeList" :key="index"
               @click="onChangeHeader('programUuid',items)">
              {{ items.title }}
            </p>
          </div>
        </div>
        <div class="businessSearch flex">
          <div class="businessSearchName">发布时间</div>
          <div class="businessSearchItem" style="margin-bottom: 10px;">
            <p :class="params.dateType === items.uuid? 'businessSearch_m1': 'businessSearch_m'"
               v-for="(items, index) in paramsDateList" :key="index"
               @click="onChangeHeader('dateType',items)">
              {{ items.title }}
            </p>
            <el-date-picker
                v-model="params.dateRange"
                type="daterange"
                clearable
                @change="onChangeDate"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="margin-left: 20px;"
            >
            </el-date-picker>
          </div>

          <div class="businessSearchName" style="margin-left: 50px;">状态</div>
          <div  style="margin-bottom: 10px;width: 120px">
            <el-select v-model="params.isEnd" @change="changeEnd($event)"  placeholder="请选择状态" style="width: 120px !important;">
              <el-option label="全部" value=""></el-option>
              <el-option label="进行中" value="0"></el-option>
              <el-option label="已结束" value="1"></el-option>
            </el-select>
          </div>
        </div>
        <div class="businessSearch flex">
          <div class="businessSearchName" style="letter-spacing: 11px;margin-bottom: 4px;">区 域</div>
          <div class="businessSearchItem" style="margin-bottom: 0px;">
            <el-cascader
                ref="refCascader"
                v-model="params.city"
                :options="areaList"
                :props="areaProps"
                clearable
                filterable
                @change="handleAreaChange">
            </el-cascader>
          </div>
          <div class="businessSearchName" style="letter-spacing: 7px;margin-left: 55px; margin-bottom: 4px;">关键字</div>
          <div class="businessSearchItem" style="margin-bottom: 0px;">
            <div style="display: flex;">
              <el-input placeholder="请输入内容" clearable v-model="params.title"
                        @clear="getBusinessSearchList"></el-input>
              <div class="btn-search" @click="getBusinessSearchList">搜索</div>
            </div>
          </div>
        </div>
      </el-card>
      <div class="container">
        <div class="top-list-img"
             :style="{ backgroundImage: `url(${advTopBgUrl})` }">
        </div>
      </div>
      <div class="list-box">
        <div style="display: flex;">
          <div class="list-left">
            <section class="softwareList">
              <ul v-if="searchList.length!==0">
                <li v-for="(item, index) in searchList" :key="index">
                  <div class="list-item-box" @click="onClickDetail(item)">
                    <div class="list-item-title">
                      <div class="item-title-box">
                        <div class="item-title-type">{{ item.programName }}</div>
                        <div class="item-title-text">{{ item.title }}</div>
                      </div>
                      <div class="item-title-time">发布日期：{{ item.publishDate }}</div>
                    </div>
                    <el-row :gutter="30" class="list-item-size" style="margin-top: 10px;">
                      <el-col :span="10">招标方式：{{ item.buyMethod }}</el-col>
                      <el-col :span="10">截止时间：{{ item.effectDate }}</el-col>
                      <el-col :span="4">
                        <div v-if="params.programUuid==3" >
                          <div class="list-item-status" >
                            中标公示
                          </div>
                        </div>
                        <div v-else >
                          <div v-if="item.isEnd==1" class="list-item-status" >
                            招标结束
                          </div>
                          <div v-else  class="list-item-status" style="background:#009999 !important">
                            招标进行中
                          </div>
                        </div>

                      </el-col>
                    </el-row>
                    <el-row :gutter="30" class="list-item-size">
                      <el-col :span="10">招标产品：{{ item.buyProduct }}</el-col>
                      <el-col :span="10">招标地区：{{ item.city }}</el-col>
                      <el-col :span="4"></el-col>
                    </el-row>
                  </div>
                </li>
              </ul>
              <div v-else style="text-align:center;margin-bottom:20px;margin-top:20px">
                <img src="../../assets/nosearchMesg.jpg" alt="" style="width:200px">
              </div>
              <div style="text-align: center;padding: 10px 0;">
                <el-pagination
                    @current-change="onChangeCurrent"
                    :current-page="params.current"
                    :page-size="params.pageSize"
                    background
                    layout="prev, pager, next"
                    :total="params.total">
                </el-pagination>
              </div>
            </section>
          </div>
          <div class="list-right-img"  v-if="!isLogin" @click="onClickRightAdv"
               :style="{ backgroundImage: `url(${advRightBg.value})` }">
          </div>
          <div v-else class="list-right-img">
            <img src="../../assets/list_banner.jpg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getDictionaryItem, getFrontCityTree, getFrontItemList, getFrontProgramList} from "../../utils/interface";
import {mapState} from "vuex";

export default {
  //   商机线索列表页
  name: "saasList",
  metaInfo: {
    title: '商机线索-水泵云', // set a title
    meta: [{                 // set meta
      name: 'keywords',
      content: 'saas平台 | 信息化软件 |人力资源软件 | SRM |crm |MES系统 | 生产管理软件 | 党建管理软件'
    }, {                 // set meta
      name: 'description',
      content: '水泵云商机线索提供人力资源、行政、采购、营销、财务、党政等信息化产品软件服务，为水泵行业企业提供完整的信息化解决方案。'
    }],
  },
  components: {},
  data() {
    return {
      searchList: [],
      params: {
        programUuid: '-1',
        dateType: '-1',
        dateRange: [],
        startTime: '',
        endTime: '',
        title: '',
        city: '',
        cityType: '',
        status: '1',
        isEnd:'',
        current: 1,
        pageSize: 10,
        total: 0,
      },
      paramsTypeList: [],
      paramsDateList: [
        {title: '全部', uuid: '-1'},
        {title: '今天', uuid: 'TODAY'},
        // {title: '近三天', uuid: 'THREE'},
        {title: '近一周', uuid: 'WEEK'},
        {title: '近一个月', uuid: 'MONTH'},
      ],
      advTopBgUrl: '',
      advRightBg: '',
      areaList: [],
      isEndList: ["已结束","进行中"],
      areaProps: {
        label: 'name',
        value: 'uuid',
        children: 'provinceList',
      },
    };
  },
  computed: {
    ...mapState({
      isLogin: "isLogin",
    }),
  },
  created() {
    this.params.title = this.$route.query.search;
    this.params.programUuid = this.$route.query.programUuid;
    if (this.$route.query.cityUuid && this.$route.query.type) {
      this.params.city = this.$route.query.cityUuid
      this.params.cityType = this.$route.query.type
    }
    this.getBusinessSearchList();
    this.getOptionsData()
  },
  methods: {
    getBusinessSearchList() {
      let data = JSON.parse(JSON.stringify(this.params))
      if (this.params.dateRange.length) {
        data.startTime = this.params.dateRange[0]
        data.endTime = this.params.dateRange[1]
        delete data.dateType
      } else {
        delete data.startTime
        delete data.endTime
      }
      if (this.params.programUuid === '-1') {
        delete data.programUuid
      }
      if (this.params.dateType === '-1') {
        delete data.dateType
      }
      delete data.dateRange
      getFrontItemList(data).then((res) => {
        this.searchList = res.list;
        this.params.total = res.total;
      })
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    onClickDetail(item) {
      let routeData = this.$router.resolve({
        name: "businessSearchDetails",
        params: {uuid: item.uuid},
        query: {
          titleName: "商机列表",
          titleForm: "businessSearchList",
        }
      });
      window.open(routeData.href, "_blank");
    },
    handleAreaChange(e) {
      let nodesObj = this.$refs['refCascader'].getCheckedNodes()
      console.log(nodesObj)
      if (nodesObj.length) {
        this.params.city = nodesObj[0].data.uuid
        this.params.cityType = nodesObj[0].data.type
      } else {
        this.params.city = ''
        this.params.cityType = ''
      }
      this.getBusinessSearchList()
    },
    getOptionsData() {
      getFrontProgramList().then((res) => {
        if (res) {
          this.paramsTypeList = [{title: '全部', uuid: '-1'}, ...res]
        } else {
          this.paramsTypeList = [{title: '全部', uuid: '-1'}]
        }
      });

      getDictionaryItem({
        code: 'LIST-MEMBER-ADV'
      }).then((res) => {
        if (res != null && res.length > 0) {
          this.advTopBgUrl = res[0].value
        }
      });

      getDictionaryItem({
        code: 'LIST-RIGHT-ADV'
      }).then((res) => {
        if (res != null && res.length > 0) {
          this.advRightBg = res[0]
        }
      });

      getFrontCityTree().then((res) => {
        if (res.data) {
          this.areaList = res.data
        }
      });
    },
    onClickRightAdv() {
      if (this.advRightBg.linkUrl) {
        window.open(this.advRightBg.linkUrl, "_blank");
      } else {
        this.$message.warning('跳转链接为空！')
      }
    },
    onChangeHeader(key, item) {
      if (key === 'programUuid' && item.type === 2) {
        window.open(item.url, "_blank");
      } else {
        if (key === 'dateType') {
          this.params.dateRange = []
        }
        this.params[key] = item.uuid
        this.getBusinessSearchList()
      }
    },
    onChangeDate(e) {
      if (!e) {
        this.params.dateType = '-1'
        this.params.dateRange = []
      } else {
        this.params.dateType = ''
      }
      this.getBusinessSearchList()
    },
    onChangeCurrent(e) {
      this.params.current = e
      this.getBusinessSearchList()
    },
    handleSizeChange(e) {
      console.log(e)
    },
    changeEnd(e){
      let data = JSON.parse(JSON.stringify(this.params))
      if (this.params.dateRange.length) {
        data.startTime = this.params.dateRange[0]
        data.endTime = this.params.dateRange[1]
        delete data.dateType
      } else {
        delete data.startTime
        delete data.endTime
      }
      if (this.params.programUuid === '-1') {
        delete data.programUuid
      }
      if (this.params.dateType === '-1') {
        delete data.dateType
      }
      delete data.dateRange
      data.isEnd = e;
      getFrontItemList(data).then((res) => {
        this.searchList = res.list;
        this.params.total = res.total;
      })
    },
  },
};
</script>

<style scoped lang="less">

.business-search-list {
  background: #f4f4f4;

  .top-list-img {
    height: 80px;
    width: 100%;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 15px 0 20px;
    cursor: pointer;
  }


  .container {
    width: 1200px;
    margin: 0 auto;

    .search-box {
      font-size: 14px;
      margin-bottom: 10px;

      .businessSearch {
        align-items: center;

        .businessSearchName {
          width: 100px;
          box-sizing: border-box;
          color: #2c2f37;
          margin-bottom: 14px;
          font-size: 14px;
          font-weight: bold;
        }

        .businessSearchItem {
          display: flex;
          margin-bottom: 10px;
          flex-wrap: wrap;

          /deep/ .el-input__inner {
            border-bottom-right-radius: 0;
            border-top-right-radius: 0;
            font-size: 14px !important;
          }

          /deep/ .el-input__icon {
            line-height: 24px;
          }

          /deep/ .el-date-editor .el-range-separator {
            line-height: 24px;
          }

          /deep/ .el-input {
            width: 300px;
          }

          .btn-search {
            width: 62px;
            height: 30px;
            line-height: 30px;
            background: #019999;
            color: white;
            text-align: center;
            cursor: pointer;
          }
        }

        .businessSearch_m {
          cursor: pointer;
          padding: 3px 15px;
          font-size: 14px;
        }

        .businessSearch_m1 {
          cursor: pointer;
          border-radius: 5px;
          color: #009999;
          padding: 3px 15px;
          font-size: 14px;
        }

        /deep/ .el-select {
          margin-right: 20px;
          width: 148px;
        }

        /deep/ .el-input__inner {
          height: 30px;
          padding: 0px 10px;
        }

        /deep/ .el-input__icon {
          line-height: 30px;
        }

        /deep/ .el-cascader {
          margin-left: 10px;
        }

        .addMess {
          align-items: center;
          cursor: pointer;
          padding: 3px 15px;

          p {
            margin-right: 5px;
          }

          .addMessIcon {
            flex-direction: column;
            display: flex;

            i {
              // font-size: 10px;
            }
          }
        }

        .p_active {
          cursor: pointer;
          background: #009999;
          border-radius: 5px;
          color: #fff;
          padding: 3px 15px;
          font-size: 14px;
        }
      }
    }

    .softwareList {
      background: #fff;
    }
  }

  .list-box {
    padding-bottom: 30px;

    .list-left {
      width: calc(100% - 270px - 15px);
      margin-right: 15px;
    }

    .list-right-img {
      height: 410px;
      width: 270px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      cursor: pointer;
      transition: all .2s;
    }

    .list-right-img:hover {
      background-size: 110% 110%;
    }

    .list-item-box {
      padding: 30px 20px 20px 20px;
      border-bottom: 1px solid #eee;
      cursor: pointer;
      transition: all .2s;
    }

    .list-item-box:hover {
      //transform: scale(1.01);

      .item-title-text {
        color: #019999;
      }

      .item-title-time {
        color: #333333;
      }
    }

    .list-item-title {
      display: flex;
      justify-content: space-between;
      padding-bottom: 5px;
      line-height: 24px;
      width: 100%;

      .item-title-type {
        width: 72px;
        white-space: nowrap;
        padding: 0 6px;
        line-height: 24px;
        height: 24px;
        background: #ededed;
        font-size: 14px;
        color: #333333;
        text-align: center;
        margin-right: 10px;
        margin-top: 5px;
      }

      .item-title-text {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        overflow: hidden;
        //文本超出部分以...形式展示，同第一行样式代码
        text-overflow: ellipsis;
        //display 块级元素展示
        display: -webkit-box;
        //设置文本行数为2行
        -webkit-line-clamp: 3;
        //设置文本行数为2行
        line-clamp: 3;
        //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
        -webkit-box-orient: vertical;
        line-height: 26px;
      }

      .item-title-box {
        display: flex;
        overflow: hidden;
        width: 78%;
      }

      .item-title-time {
        width: 20%;
        font-size: 14px;
        color: #cbcbcb;
        text-align: right;
      }
    }

    .list-item-size {
      font-size: 14px;
      color: #333333;
    }

    .list-item-status {
      width: 110px;
      height: 30px;
      line-height: 30px;
      background: #9d9d9d;
      border-radius: 20px;
      font-size: 16px;
      font-weight: bold;
      color: #FEFEFE;
      text-align: center;
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/components/businessSearch/businessSearchList.vue